
export enum ZoneIndicatorCd {
	INCLUDE_ZONES = 'IncludeZones',
	NO_ZONES = 'NoZones',
	ZONES_ONLY = 'ZonesOnly'}

